<template>
  <div class="mains">
    <div class="campus">
      功能模块
      <span>></span>
      <router-link to="testing">单词训练</router-link>
      <span>></span>
      <span @click="tiaozhuan_wjc">上传闪卡</span>
      <span>></span>
      <router-link to>编辑闪卡</router-link>
    </div>
    <div class="xiaoqu">
      <el-card :span="24">
        <div class="xiaoqu_1">编辑闪卡</div>
        <div class="shenzhong">
          <i class="img_1"> <img src="@/assets/img/education-manage/campus/shenzhong.png" alt /> </i>
          您所上传制作的闪卡练习可直接进行单词及图片的上传，后台将自动为您解析出音频。
        </div>

        <el-button type="primary" @click="add_xinzeng" style="margin: -0.5vw 0 0 1.5vw">
          新增闪卡
        </el-button>
        <div class="grid-content">
          <div class="zsbg shanka_list">
            <el-table :data="tableData" border>
              <el-table-column prop="english" label="闪卡内容（英文）">
              </el-table-column>
              <el-table-column prop="chinese" label="闪卡内容（中文）"></el-table-column>

              <el-table-column label="操作">
                <template slot-scope="stData">
                  <el-button type="text" @click="getWordPracticeResById(stData.row.id)">
                    修改闪卡
                  </el-button>
                  <el-button type="text" @click="deleteWordPracticeRes(stData.row.id)">
                    删除闪卡
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>

        <div class="grid-content">
          <el-dialog class="yl_shanka xg_shanka" title="修改闪卡" :visible.sync="addStudents">
            <div class="form_1 right kbfm">
              <el-form ref="forms" :model="form" :rules="FormRules" label-width="5.20833vw">
                <el-form-item label="闪卡英文" prop="english">
                  <i>
                    <img src="@/assets/img/education-manage/campus/bitian.png" alt />
                  </i>
                  <el-input v-model="form.english" placeholder="请输入课本名称 ( 可填写中英文，不超过15个字 )"></el-input>
                </el-form-item>

                <el-form-item label="闪卡中文" prop="chinese">
                  <i>
                    <img src="@/assets/img/education-manage/campus/bitian.png" alt />
                  </i>
                  <el-input v-model="form.chinese" placeholder="请输入课本名称 ( 可填写中英文，不超过15个字 )"></el-input>
                </el-form-item>

                <el-form-item class="shangchuan_lbt" label="闪卡音频" prop="picurl">
                  <i>
                    <img src="@/assets/img/education-manage/campus/bitian.png" alt />
                  </i>
                  <el-upload class="avatar-uploader xuigai_yin" action="#" :show-file-list="false" :http-request="handleAvatarSuccess2" :before-upload="beforeAvatarUpload2">
                    <el-button size="small" type="primary">修改音频</el-button>
                  </el-upload>
                  <div class="yipin">
                    <audio controls controlsList="nodownload" style="width: 100%; height: 100%" :src="voiceurl"></audio>
                  </div>
                </el-form-item>

                <el-form-item class="shangchuan_lbt" label="闪卡图片" prop="picurl">
                  <i>
                    <img src="@/assets/img/education-manage/campus/bitian.png" alt />
                  </i>
                  <el-upload class="avatar-uploader" action="#" :show-file-list="false" :http-request="handleAvatarSuccess" :before-upload="beforeAvatarUpload0">
                    <img v-if="tempImg" :src="tempImg" class="avatar1" />
                    <i v-else class="el-icon-plus avatar-uploader-icon1"></i>
                  </el-upload>
                </el-form-item>
                <div class="form_1_1">
                  <el-form-item class="queding">
                    <el-button type="primary" @click="updateOneWordPracticeRes">
                      确定
                    </el-button>
                    <el-button @click="quxiao">取消</el-button>
                  </el-form-item>
                </div>
              </el-form>
            </div>
          </el-dialog>

          <el-dialog class="yl_shanka xg_shanka" title="新增闪卡" :disabled="disabled0" :visible.sync="addStudents1">
            <div class="form_1 right kbfm">
              <el-form ref="forms" :model="form1" :rules="FormRules" label-width="5.20833vw">
                <el-form-item label="闪卡英文" prop="english">
                  <i>
                    <img src="@/assets/img/education-manage/campus/bitian.png" alt />
                  </i>
                  <el-input v-model="form1.english" placeholder="请输入课本名称 ( 可填写中英文，不超过15个字 )"></el-input>
                </el-form-item>

                <el-form-item label="闪卡中文" prop="chinese">
                  <i>
                    <img src="@/assets/img/education-manage/campus/bitian.png" alt />
                  </i>
                  <el-input v-model="form1.chinese" placeholder="请输入课本名称 ( 可填写中英文，不超过15个字 )"></el-input>
                </el-form-item>

                <el-form-item class="shangchuan_lbt" label="闪卡音频" prop="picurl">
                  <i>
                    <img src="@/assets/img/education-manage/campus/bitian.png" alt />
                  </i>
                  <el-upload class="avatar-uploader xuigai_yin" action="#" :show-file-list="false" :http-request="handleAvatarSuccess2s" :before-upload="beforeAvatarUpload2">
                    <el-button size="small" type="primary">上传音频</el-button>
                  </el-upload>
                  <div class="yipin">
                    <audio controls controlsList="nodownload" style="width: 100%; height: 100%" :src="voiceurl1"></audio>
                  </div>
                </el-form-item>

                <el-form-item class="shangchuan_lbt" label="闪卡图片" prop="picurl">
                  <i>
                    <img src="@/assets/img/education-manage/campus/bitian.png" alt />
                  </i>
                  <el-upload class="avatar-uploader" action="#" :show-file-list="false" :http-request="handleAvatarSuccess1" :before-upload="beforeAvatarUpload0">
                    <img v-if="tempImg1" :src="tempImg1" class="avatar1" />
                    <i v-else class="el-icon-plus avatar-uploader-icon1"></i>
                  </el-upload>
                </el-form-item>
                <div class="form_1_1">
                  <el-form-item class="queding">
                    <el-button type="primary" @click="addOneWordPracticeRes">
                      确定
                    </el-button>
                    <el-button @click="quxiao">取消</el-button>
                  </el-form-item>
                </div>
              </el-form>
            </div>
          </el-dialog>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'testingear',
  data() {
    return {
      FormRules: {},
      banji_id: {},
      banji_ids: {},
      tableData: [],
      addStudents: false,
      addStudents1: false,
      form: {},
      form1: {
        english: '',
        chinese: '',
      },
      tempImg: '',
      tempImg1: '',
      voiceurl: '',
      voiceurl1: '',
      disabled0: false,
    };
  },
  created() {
    if (!this.$store.state.testingear1) {
      this.$router.push({ name: 'testingear' });
      return this.$message.error('您当前的章节数据获取失败！');
    }
    this.banji_id = this.$store.state.testingear1;
    this.banji_ids = this.$store.state.testingearbs;

    this.getWordPracticeViewById();
  },
  destroyed() {
    localStorage.removeItem('testingear1');
    localStorage.removeItem('testingearbs');
  },
  watch: {},
  methods: {
    tiaozhuan_wjc() {
      this.$store.commit('testing', this.banji_ids);
      this.$router.push({ name: 'testingear' });
    },

    handleAvatarSuccess(data) {
      let orgid = window.sessionStorage.getItem('orgid');
      let formData = new FormData();
      formData.append('file', data.file);
      formData.append('orgid', orgid);
      // console.log(formData)
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/wordpractice/uploadimage',
        method: 'POST',
        data: formData,
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          if (result.data.code === 0) {
            let url = result.data.data;
            this.tempImg = url;
          } else {
            this.$message.error(result.data.message);
          }
          // console.log(this.tempImg)
        })
        .catch((err) => {
          // console.log('error===============')
          this.$message.error('系统错误：' + err);
        });
    },

    handleAvatarSuccess1(data) {
      let orgid = window.sessionStorage.getItem('orgid');
      let formData = new FormData();
      formData.append('file', data.file);
      formData.append('orgid', orgid);
      // console.log(formData)
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/wordpractice/uploadimage',
        method: 'POST',
        data: formData,
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          if (result.data.code === 0) {
            let url = result.data.data;
            this.tempImg1 = url;
          } else {
            this.$message.error(result.data.message);
          }
          // console.log(this.tempImg)
        })
        .catch((err) => {
          // console.log('error===============')
          this.$message.error('系统错误：' + err);
        });
    },

    handleAvatarSuccess2(data) {
      let orgid = window.sessionStorage.getItem('orgid');
      let formData = new FormData();
      formData.append('audiofile', data.file);
      formData.append('orgid', orgid);
      // console.log(formData)
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/wordpractice/uploadAudio',
        method: 'POST',
        data: formData,
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          // console.log(result)
          if (result.data.code === 0) {
            let url = result.data.data;
            this.voiceurl = url;
          } else {
            this.$message.error(result.data.message);
          }
          // console.log(this.tempImg)
        })
        .catch((err) => {
          // console.log('error===============')
          this.$message.error('系统错误：' + err);
        });
    },

    handleAvatarSuccess2s(data) {
      let orgid = window.sessionStorage.getItem('orgid');
      let formData = new FormData();
      formData.append('audiofile', data.file);
      formData.append('orgid', orgid);
      // console.log(formData)
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/wordpractice/uploadAudio',
        method: 'POST',
        data: formData,
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          // console.log(result)
          if (result.data.code === 0) {
            let url = result.data.data;
            this.voiceurl1 = url;
          } else {
            this.$message.error(result.data.message);
          }
          // console.log(this.tempImg)
        })
        .catch((err) => {
          // console.log('error===============')
          this.$message.error('系统错误：' + err);
        });
    },

    beforeAvatarUpload0(file) {
      const isJPG = file.type === 'image/jpeg';
      const isPNG = file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 1;

      if (!isJPG && !isPNG) {
        this.$message.error('上传图片只能是 JPG/PNG 格式!');
        return false;
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 1MB!');
        return false;
      }
      return isJPG | isPNG && isLt2M;
    },

    beforeAvatarUpload2(file) {
      const flieArr = file.name.split('.');
      const isMP3 = flieArr[flieArr.length - 1] === 'mp3';
      const isLt2M = file.size / 1024 / 1024 < 100;

      if (!isMP3) {
        this.$message.error('上传音频只能是 MP3 格式!');
        return false;
      }
      if (!isLt2M) {
        this.$message.error('上传音频大小不能超过 100MB!');
        return false;
      }
      return isMP3 && isLt2M;
    },

    quxiao() {
      if (this.addStudents) {
        this.addStudents = false;
      }
      if (this.addStudents1) {
        this.addStudents1 = false;
      }
    },

    add_xinzeng() {
      this.addStudents1 = true;
    },

    // 新增闪卡
    addOneWordPracticeRes() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      // let orgid = window.sessionStorage.getItem('orgid')
      let pro = this.$http({
        url: '/edu/wordpractice/addOneWordPracticeRes',
        method: 'POST',
        data: {
          practiceid: this.banji_id,
          english: this.form1.english,
          chinese: this.form1.chinese,
          picurl: this.tempImg1,
          voiceurl: this.voiceurl1,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          // console.log(result)
          if (result.data.code === 0) {
            this.addStudents1 = false;
            this.getWordPracticeViewById();
            this.form1.english = '';
            this.form1.chinese = '';
            this.form1.tempImg1 = '';
            this.form1.voiceurl1 = '';
            return this.$message.success('新增成功！');
          } else {
            return this.$message.error(result.data.message);
          }
        })
        .catch((err) => {
          // console.log(err)
          return this.$message.error('新增闪卡失败：' + err);
        });
    },

    // 修改闪卡信息
    updateOneWordPracticeRes() {
      // console.log(this.form)
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      // let orgid = window.sessionStorage.getItem('orgid')
      let pro = this.$http({
        url: '/edu/wordpractice/updateOneWordPracticeRes',
        method: 'POST',
        data: {
          id: this.form.id,
          practiceid: this.banji_id,
          english: this.form.english,
          chinese: this.form.chinese,
          picurl: this.tempImg,
          voiceurl: this.voiceurl,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          console.log(result);
          if (result.data.code === 0) {
            this.addStudents = false;
            this.getWordPracticeViewById();
            return this.$message.success('修改成功！');
          } else {
            return this.$message.error(result.data.message);
          }
        })
        .catch((err) => {
          // console.log(err)
          return this.$message.error('修改闪卡信息失败：' + err);
        });
    },

    // 查询修改闪卡信息
    getWordPracticeResById(id) {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      // let orgid = window.sessionStorage.getItem('orgid')
      let pro = this.$http({
        url: '/edu/wordpractice/getWordPracticeResById/' + id,
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          // console.log(result)
          if (result.data.code === 0) {
            this.addStudents = true;
            this.form = result.data.data;
            this.tempImg = this.form.picurl;
            this.voiceurl = this.form.voiceurl;
          } else {
            return this.$message.error(result.data.message);
          }
        })
        .catch((err) => {
          // console.log(err)
          return this.$message.error('查询修改闪卡信息失败：' + err);
        });
    },

    // 查询闪卡信息
    getWordPracticeViewById() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      // let orgid = window.sessionStorage.getItem('orgid')
      let pro = this.$http({
        url: '/edu/wordpractice/getWordPracticeViewById/' + this.banji_id,
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          // console.log(result)
          if (result.data.code === 0) {
            this.tableData = result.data.data;
            if (this.tableData.length >= 20) {
              this.disabled0 = true;
            } else {
              this.disabled0 = false;
            }
          } else {
            return this.$message.error(result.data.message);
          }
        })
        .catch((err) => {
          // console.log(err)
          return this.$message.error('查询闪卡信息失败：' + err);
        });
    },

    // 删除闪卡
    deleteWordPracticeRes(id) {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      this.$confirm('确认要删除吗?', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        // axios请求服务器端实现删除
        let pro = this.$http({
          url: '/edu/wordpractice/deleteWordPracticeRes/' + id,
          method: 'POST',
          headers: {
            Authorization: 'Bearer ' + token,
          },
        });
        pro
          .then((result) => {
            // console.log(result)
            if (result.data.code === 0) {
              this.getWordPracticeViewById();
              return this.$message.success('删除闪卡成功!');
            } else {
              return this.$message.error(result.data.message);
            }
          })
          .catch((err) => {
            // console.log(err)
            return this.$message.error('删除闪卡失败：' + err);
          });
      });
    },
  },
};
</script>

<style lang="less">
.el-button--primary:focus,
.el-button--primary:hover {
  background: #00a6e6;
  border-color: #00a6e6;
  color: #fff;
}
.el-button--primary {
  color: #fff;
  background-color: #00a6e6;
  border-color: #00a6e6;
}
.lianzi1 {
  left: -56px !important;
}

.mains .xiaoqu .grid-content .xg_shanka .el-dialog .form_1_1 .queding {
  margin-left: 390px;
}
.mains .xiaoqu .grid-content .xg_shanka {
  .el-dialog {
    width: 800px !important;
  }
  .el-dialog__header {
    width: 740px !important;
  }
}
.mains {
  .xg_shanka {
    .form_1 {
      margin-left: 0 !important;
    }
    .kbfm .avatar-uploader-icon1 {
      width: 120px !important;
      height: 120px !important;
      line-height: 120px !important;
    }
    .kbfm .shangchuan_lbt {
      .yipin {
        width: 400px;
        height: 28px;
        // position: absolute;
        // top: 5px;
        // left: 120px;
      }
      .xuigai_yin {
        margin-top: -7px;
        .el-upload {
          border: none;
        }
        .el-button--primary {
          margin-left: 0;
          width: 89px;
          height: 34px;
          font-size: 14px;
          border-radius: 8px;
        }
      }
      .avatar1 {
        width: 120px !important;
        height: 120px !important;
      }
    }
  }
  .xiaoqu .grid-content .shanka_list .el-table {
    .el-table_1_column_1 {
      text-align: center;
      padding-left: 0;
    }
    .el-table_1_column_2 {
      text-align: center;
      padding-left: 0;
    }
  }
}
</style>
